export default [
  {
    path: "/operation",
    name: "运营管理",
    component: (resolve) => require(["@/views/home"], resolve),
    children: [
      {
        path: "statistics",
        name: "运营管理统计",
        meta: {
          title: "运营管理统计",
        },
        component: (resolve) =>
          require(["@/views/operation/statistics"], resolve),
      },
      {
        path: "journalManagement",
        name: "期刊信息管理 ",
        meta: {
          title: "期刊信息管理",
        },
        component: (resolve) =>
          require(["@/views/operation/journalManagement"], resolve),
      },
      {
        path: "programManage",
        name: "栏目管理",
        meta: {
          title: "栏目管理",
        },
        component: (resolve) =>
          require(["@/views/operation/programManage"], resolve),
      },
      {
        // 2022/11 版本更新，修改名称 ：刊期管理 -》 刊期及三审记录管理
        // 2022/02 版本更新 修改名称：刊期及三审记录管理 -》 刊期及审核记录管理
        path: "periodicalManage",
        name: "刊期及审核记录管理 ",
        meta: {
          title: "刊期及审核记录管理",
        },
        component: (resolve) =>
          require(["@/views/operation/periodicalManage/index"], resolve),
      },
      {
        path: "manuscriptManage",
        name: "稿件查询",
        meta: {
          title: "稿件查询",
        },
        component: (resolve) =>
          require(["@/views/operation/manuscriptManage/index"], resolve),
      },
      {
        path: "Modify",
        name: "修改稿件",
        meta: {
          title: "修改稿件",
        },
        component: (resolve) =>
          require(["@/views/operation/manuscriptManage/Modify/index"], resolve),
      },
      {
        path: "articleDetail",
        name: "稿件详情",
        meta: {
          title: "稿件详情",
        },
        component: (resolve) =>
          require(["@/views/operation/articleDetail"], resolve),
      },
      {
        path: "orderInquiry",
        name: "订单查询",
        meta: {
          title: "订单查询",
        },
        component: (resolve) =>
          require(["@/views/operation/orderInquiry/index"], resolve),
      },
      {
        path: "authorManagement",
        name: "作者管理",
        meta: {
          title: "作者管理",
        },
        component: (resolve) =>
          require(["@/views/operation/authorManagement/index"], resolve),
      },
      {
        path: "expertManagement",
        name: "专家管理",
        meta: {
          title: "专家管理",
        },
        component: (resolve) =>
          require(["@/views/operation/expertManagement/index"], resolve),
      },
      {
        path: "expertManagement/expertManagementSave",
        name: "专家管理",
        meta: {
          title: "专家管理",
        },
        component: (resolve) =>
          require([
            "@/views/operation/expertManagement/expertManagementSave",
          ], resolve),
      },
      {
        path: "caibianPerf",
        name: "绩效管理",
        meta: {
          title: "绩效管理",
        },
        component: (resolve) =>
          require(["@/views/operation/caibianPerf/index"], resolve),
      },
      {
        path: "administration",
        name: "采编名片管理",
        meta: {
          title: "采编名片管理",
        },
        component: (resolve) =>
          require(["@/views/operation/administration/index"], resolve),
      },
      {
        path: "acceptanceRejection",
        name: "退稿审核",
        meta: {
          title: "退稿审核",
        },
        component: (resolve) =>
          require(["@/views/operation/acceptanceRejection/index"], resolve),
      },
      {
        path: "acceptanceWithdrawal",
        name: "退修审核",
        meta: {
          title: "退修审核",
        },
        component: (resolve) =>
          require(["@/views/operation/acceptanceWithdrawal/index"], resolve),
      },
      {
        path: "articleExamine",
        name: "退修申请审核",
        meta: {
          title: "退修申请审核",
        },
        component: (resolve) =>
          require(["@/views/operation/acceptanceWithdrawal/articleExamine/index"], resolve),
      },
      {
        path: "examineDetail",
        name: "退修申请审核",
        meta: {
          title: "退修申请审核",
        },
        component: (resolve) =>
          require(["@/views/operation/acceptanceWithdrawal/examineDetail/index"], resolve),
      },
      {
        path: "orderDiscount",
        name: "订单优惠审核",
        meta: {
          title: "订单优惠审核",
        },
        component: (resolve) =>
          require(["@/views/operation/orderDiscount/index"], resolve),
      },
      ,
      {
        path: "fundAuditf",
        name: "基金审核",
        meta: {
          title: "基金审核",
        },
        component: (resolve) =>
          require(["@/views/operation/fundAuditf/index"], resolve),
      },
      {
        path: "caibianCards",
        name: "采编名片管理 ",
        meta: {
          title: "采编名片管理",
        },
        component: (resolve) =>
          require(["../views/operation/caibianCards"], resolve),
      },
      {
        path: "refundAudit",
        name: "退款审核",
        meta: {
          title: "退款审核",
        },
        component: (resolve) =>
          require(["@/views/operation/refundAudit/index"], resolve),
      },
    ],
  },
  {
    path: "/reviewCustomLogin",
    name: "自定义登录页面预览",
    component: (resolve) => require(["@/views/operation/reviewCustomLogin"], resolve),
  }
];



// WEBPACK FOOTER //
// ./src/router/operation_routers.js